import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { defaultFixturesExportFieldNames } from "~pages/Fixtures/FixtureListPage/constants/exportFields.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useExportFixtures = () => {
  const { sport = "", organizationId = "", seasonId = "" } = useParams();
  const request = useApi();
  return useMutation<DefaultOperationSuccessResponse, Error, Array<string>>({
    mutationFn: async (fieldNames: Array<string>) => {
      const body = {
        fieldNames: fieldNames || defaultFixturesExportFieldNames,
      };
      return await request(`${sport}/o/${organizationId}/seasons/${seasonId}/fixtures/export`, {
        method: "POST",
        body,
      });
    },
  });
};
